module.exports = __webpack_public_path__ + "img/ZoomGreen&White.d3e6aaa4.png";